import { answered, stores } from "./loader";

// One store per widget name, filled by load and handed out by fetch.
const kept = stores(
  (def) => def.t === "widget" && def.r && def.r.val,
  () => /** @type {import('./definition').definition[]} */ ([]),
);

/**
 * Fetches the definitions for a widget
 * @param {string} name - widget name
 * @returns {Promise<import('./definition').definition[]>}
 */
function fetchWidget(name) {
  return answered(fetch(`/api/widget/${name}`));
}

/**
 * Loads each widget the definitions name, and each one those widgets name,
 * once each, into its store
 * @param {import('./definition').definition[]} defs - definitions to search
 * @param {Set<string>} asked - the widget names already asked for
 * @param {(defs: unknown) => Promise<void>} ready - what each widget's definitions wait on before they are drawn
 */
function loadAll(defs, asked, ready) {
  kept
    .names(defs)
    .filter((name) => !asked.has(name))
    .forEach((name) => {
      asked.add(name);
      fetchWidget(name).then(async (definitions) => {
        await ready(definitions);
        kept.keep(name, definitions);
        loadAll(definitions, asked, ready);
      });
    });
}

const widgets = {
  /**
   * Fetches a widget from the local store
   * @param {string} name - name of a widget
   * @returns {Promise<import("svelte/store").Writable<import('./definition').definition[]>>}
   */
  fetch: kept.fetch,
  /**
   * Loads the widgets from the API into individual local stores
   * @param {import('./definition').definition[]} defs - list of widget names
   * @param {(defs: unknown) => Promise<void>} [ready] - what each widget's definitions wait on before they are drawn
   */
  load: async (defs, ready = async () => {}) => {
    loadAll(defs, new Set(), ready);
  },
};

export default widgets;
